<template>
  <div id="app">
  <!-- 全局禁止点击的div -->
<div    style="height:100%" element-loading-text="正在处理中，请稍后"  v-loading.fullscreen="$store.getters.isstorpclick"  element-loading-background="rgba(0, 0, 0, 0.1)">
    <router-view></router-view>
</div>


    <!-- 登录的弹出层 -->
    <loginpop></loginpop>
    <!-- 点击头像的弹出层 -->
    <grzxcardpop ></grzxcardpop>
    <!-- 个人中心的弹出层 -->
    <personage></personage>
    <!-- 挽留 -->
    <wanliu></wanliu>
    <!-- 开通vip -->
    <kaitongvip></kaitongvip>
     
  </div>
</template>

<script>

// 模板已经适配, 1rem是37.5px  设计稿宽如果是375
// swiper 下载的是 5.4.5 版本的
// axios css动画库 jquery 都已下载
import kaitongvip from "@/components/kaitongvip.vue";
import loginpop from "@/components/loginpop.vue";
import grzxcardpop from "@/components/clickcardpop.vue";
import personage from "@/components/personage.vue";
import wanliu from "@/components/detainment.vue";


// 检测控制台是否打开  
import  devtools from 'devtools-detect'
import assist from './utils/commonality';

export default {
  name: 'App',
  components: {
       loginpop,
    grzxcardpop,
    personage,
    wanliu,
    kaitongvip,
  },
  methods: {

  },
  data() {
      return {
        dsq:null,
      }
  },
    mounted() {
      
// console.log(location.href);
// window.open(location.href)

// this.$nextTick(() => {
//   window.addEventListener('devtoolschange', event => {
//        let res =  assist.getParam()
//        console.log(res);
       
//   if (res.notClose !='110'  && event.detail.isOpen) {
//       this.$cardloading.cardloading2(true,'请关闭控制台，否则三秒后将关闭或离开本页面')
//             this.dsq =  setTimeout(()=>{
//                    if (navigator.userAgent.indexOf('Firefox') != -1 || navigator.userAgent.indexOf('Chrome')!= -1) {
//                      window.location.href = 'about:blank'
//                      window.close()
//                    } else {
//                      window.opener = null
//                      window.open('', '_self')
//                      window.close()
//                  }
//              },3000)
//           }else {
//               if (this.dsq) {
//                 clearTimeout(this.dsq)
//               }
//             this.$cardloading.cardloading2(false,'请关闭控制台，否则三秒后将关闭或离开本页面')
//           }
//     });
// })


  }
}


</script>

<style scoped lang="scss">
#app {
  height: 100%;
  margin: 0 auto;
  max-width:2200px;
}

</style>